
  import { defineComponent, PropType, provide, ref } from 'vue';
  import { useVuelidate } from '@vuelidate/core';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import { AGGREGATED_TABLE_PDF_EXPORT_VIRTUALIZATION_KEY } from '@/common/components/redesigned/Table/constants/exportInjection';

  import { AGGREGATED_EXPORT_PROGRESS_KEY } from '../common/ved-aggregated-export-buttons/exportInjection';
  import VedAggregatedExportButtons from '../common/ved-aggregated-export-buttons/VedAggregatedExportButtons.vue';
  import { TExportConfig } from './ved-aggregated-export-buttons/types';

  export default defineComponent({
    name: 'AggregatedPageWrapper',
    components: {
      VedAggregatedExportButtons,
      PageTitle,
    },
    setup() {
      const isTableVirtualizationDisabledForPdfExport = ref(false);
      const isExportProgress = ref(false);
      provide(AGGREGATED_TABLE_PDF_EXPORT_VIRTUALIZATION_KEY, isTableVirtualizationDisabledForPdfExport);
      provide(AGGREGATED_EXPORT_PROGRESS_KEY, isExportProgress);
      return { v$: useVuelidate() };
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      exportConfig: {
        type: Object as PropType<TExportConfig>,
        required: true,
      },
    },
    computed: {
      getIsDisabledExportButtons() {
        return this.v$.$invalid;
      },
    },
  });
